export default __webpack_public_path__ + "static/media/Cheng-Ho Battle Mark.9c6cda10.jpg";